module.exports = __webpack_public_path__ + "img/fund-1.b90d6ee1.png";